import Vue from 'vue';
import { debounce } from 'lodash';
export default Vue.extend({
    data() {
        return {
            onResize: debounce(function () {
                this.$emit('resize', document.body.clientHeight, document.body.clientWidth);
            }, 50).bind(this)
        };
    },
    mounted() {
        window.addEventListener('resize', this.onResize);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.onResize);
    },
    render() { return null; }
});
